<template>
  <vx-card title="Credit Note Temporary">
    <vs-tabs v-model="tabs">
      <vs-tab label="Waiting Reversal"> 
        <waitingRevers /> 
      </vs-tab>
      <vs-tab label="Reversed"> 
        <reversed /> 
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>

<script>
import waitingRevers from "./waiting-reversal/index.vue";
import reversed from "./reversed/index.vue";

export default {
  components: {
    reversed,
    waitingRevers,
  },
  data() {
    return {
      tabs: 0,
    };
  },
};
</script>
